import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import AuthScreen from '../components/AuthScreen'
import BorgWarnerBackground from '../components/BorgWarnerBackground'

export default function LoginPage() {
  const { user } = useAuth()
  const navigate  = useNavigate()

  // Already logged in — go straight to dashboard
  if (user) { navigate('/dashboard'); return null }

  return (
    <div className="app" style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      <BorgWarnerBackground />
      <header className="app-header" style={{ position: 'relative', zIndex: 1 }}>
        <div className="header-logo">🏎️</div>
        <div className="header-title">
          <h1>Race Day Pool</h1>
          <p>Indianapolis Motor Speedway · May 24, 2026</p>
        </div>
        <nav className="header-nav">
          <button className="nav-btn" onClick={() => navigate('/')}>← Home</button>
        </nav>
      </header>
      <main className="app-main" style={{ position: 'relative', zIndex: 1 }}>
        <AuthScreen onDone={() => navigate('/dashboard')} />
      </main>
    </div>
  )
}
